var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-space-between"},[_c('text-btn',{attrs:{"small":"","icon":"mdi-arrow-left"},on:{"click":function($event){return _vm.$emit('back')}}},[_vm._v("Вернуться к заданию")])],1),_c('div',[_c('InstructionsForm',{attrs:{"editedNote":_vm.data},on:{"close":function($event){return _vm.$emit('back')},"save":function($event){return _vm.$emit('instruction-saved', {
          data: $event,
          isEdit: !!_vm.data,
        })}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }